export const POST_LOGIN_REQUEST = 'POST_LOGIN_REQUEST';
export const POST_LOGIN_SUCCESS = 'POST_LOGIN_SUCCESS';
export const POST_LOGIN_FAIL = 'POST_LOGIN_FAIL';

export const SET_CURRENT_PRODUCT_LOGIN = 'SET_CURRENT_PRODUCT_LOGIN';

export const PRODUCT_LOGIN_REQUEST = 'PRODUCT_LOGIN_REQUEST';
export const PRODUCT_LOGIN_SUCCESS = 'PRODUCT_LOGIN_SUCCESS';
export const PRODUCT_LOGIN_FAIL = 'PRODUCT_LOGIN_FAIL';

export const FETCH_USERS_MODULES_REQUEST = 'FETCH_USERS_MODULES_REQUEST';
export const FETCH_USERS_MODULES_SUCCESS = 'FETCH_USERS_MODULES_SUCCESS';
export const FETCH_USERS_MODULES_FAIL = 'FETCH_USERS_MODULES_FAIL';

export const PUT_CHANGE_PASSWORD_REQUEST = 'PUT_CHANGE_PASSWORD_REQUEST';
export const PUT_CHANGE_PASSWORD_SUCCESS = 'PUT_CHANGE_PASSWORD_SUCCESS';
export const PUT_CHANGE_PASSWORD_FAIL = 'PUT_CHANGE_PASSWORD_FAIL';

export const PUT_CHANGE_DEFAULT_ROLE_REQUEST =
  'PUT_CHANGE_DEFAULT_ROLE_REQUEST';
export const PUT_CHANGE_DEFAULT_ROLE_SUCCESS =
  'PUT_CHANGE_DEFAULT_ROLE_SUCCESS';
export const PUT_CHANGE_DEFAULT_ROLE_FAIL = 'PUT_CHANGE_DEFAULT_ROLE_FAIL';

export const POST_LOGOUT_REQUEST = 'POST_LOGOUT_REQUEST';
export const POST_LOGOUT_DONE = 'POST_LOGOUT_DONE';

export const RESET_LOGIN = 'RESET_LOGIN';

export const RELOGIN_REQUIRED = 'RELOGIN_REQUIRED';

export function postLoginRequest(payload) {
  return {
    type: POST_LOGIN_REQUEST,
    payload
  };
}

export function postLoginSuccess(payload) {
  return {
    type: POST_LOGIN_SUCCESS,
    payload
  };
}

export function postLoginFail(payload) {
  return {
    type: POST_LOGIN_FAIL,
    payload
  };
}

export function setCurrentProductLogin(payload) {
  return {
    type: SET_CURRENT_PRODUCT_LOGIN,
    payload
  };
}

export function productLoginRequest(payload) {
  return {
    type: PRODUCT_LOGIN_REQUEST,
    payload
  };
}

export function productLoginSuccess(payload) {
  return {
    type: PRODUCT_LOGIN_SUCCESS,
    payload
  };
}

export function productLoginFail(payload) {
  return {
    type: PRODUCT_LOGIN_FAIL,
    payload
  };
}

export function fetchUsersModulesRequest(payload) {
  return {
    type: FETCH_USERS_MODULES_REQUEST,
    payload
  };
}

export function fetchUsersModulesSuccess(payload) {
  return {
    type: FETCH_USERS_MODULES_SUCCESS,
    payload
  };
}

export function fetchUsersModulesFail(payload) {
  return {
    type: FETCH_USERS_MODULES_FAIL,
    payload
  };
}

export function putChangePasswordRequest(payload) {
  return {
    type: PUT_CHANGE_PASSWORD_REQUEST,
    payload
  };
}

export function putChangePasswordSuccess(payload) {
  return {
    type: PUT_CHANGE_PASSWORD_SUCCESS,
    payload
  };
}

export function putChangePasswordFail(payload) {
  return {
    type: PUT_CHANGE_PASSWORD_FAIL,
    payload
  };
}

export function putChangeDefaultRoleRequest(payload) {
  return {
    type: PUT_CHANGE_DEFAULT_ROLE_REQUEST,
    payload
  };
}

export function putChangeDefaultRoleSuccess(payload) {
  return {
    type: PUT_CHANGE_DEFAULT_ROLE_SUCCESS,
    payload
  };
}

export function putChangeDefaultRoleFail(payload) {
  return {
    type: PUT_CHANGE_DEFAULT_ROLE_FAIL,
    payload
  };
}

export function postLogoutRequest(payload) {
  return {
    type: POST_LOGOUT_REQUEST,
    payload
  };
}

export function postLogoutDone(payload) {
  return {
    type: POST_LOGOUT_DONE,
    payload
  };
}

export function doReloginRequired() {
  return {
    type: RELOGIN_REQUIRED
  };
}

export function resetLogin() {
  return {
    type: RESET_LOGIN
  };
}
